'use client';

import { CatBreadcrumbs } from '@blocks-react/components/Breadcrumbs';
import { CatBreadcrumbsItem } from '@blocks-react/components/BreadcrumbsItem';
import {
  CatIconEllipsis,
  CatList,
  CatListItem
} from 'components/blocks-components';
import { v4 as uuid } from 'uuid';
import { useTranslations } from 'next-intl';
import { BreadCrumb as BreadCrumbType } from './types';
import { CatContextualMenu } from 'blocks-nextjs/blocks-react/components/ContextualMenu';
import styles from './bread-crumb-mobile.module.scss';
import { isExternalReferrer } from '@cat-ecom/common/utils/browserUtils';
import { useState, useEffect } from 'react';

export interface BreadCrumbClientProps {
  links: BreadCrumbType[];
  isHidingBackButton?: boolean;
  isWithoutActiveItem?: boolean;
  shouldDisplayReadOnlyItem: boolean;
}

const BreadCrumbMobileClient = ({
  links = [],
  isHidingBackButton = false,
  isWithoutActiveItem = false,
  shouldDisplayReadOnlyItem
}: BreadCrumbClientProps) => {
  const t = useTranslations();

  const [ hideBackButton, setHideBackButton ] = useState(true);
    useEffect(() => {
      const shouldHideBackButton = (typeof document !== 'undefined' &&
        isExternalReferrer(document.referrer, document.location.host)) ||
      isHidingBackButton;
      setHideBackButton(shouldHideBackButton);
    }, [isHidingBackButton]);

  const readOnlyItemStyles = shouldDisplayReadOnlyItem
    ? 'bread-crumb-last-item'
    : '';
  const linksLength = links.length;
  const lastLink = linksLength - 1;
  const onlyOneLink = linksLength === 1;
  const breadCrumbsItems = links.map(
    (item, index) =>
      index > 0 &&
      index < lastLink && (
        <CatListItem key={uuid()} href={item.value}>
          <span className="text-capitalize">{item.label}</span>
        </CatListItem>
      )
  );

  return (
    <CatBreadcrumbs>
      <div data-testid="mobileBreadcrumbs" slot="breadcrumb">
        {!hideBackButton && (
          <CatBreadcrumbsItem
            key={uuid()}
            onClick={() => history.back()}
            isMobile={true}
          >
            <span className="text-capitalize">{t('UC_BACK')}</span>
          </CatBreadcrumbsItem>
        )}
        {linksLength > 0 && (
          <CatBreadcrumbsItem
            key={uuid()}
            href={links[0].value}
            isLast={onlyOneLink}
            isActive={!isWithoutActiveItem && onlyOneLink}
          >
            <span className="text-capitalize">{links[0].label}</span>
          </CatBreadcrumbsItem>
        )}
        {linksLength > 2 && (
          <CatBreadcrumbsItem>
            <CatContextualMenu position="bottom-end" slot="showmore">
              <div slot="trigger">
                <CatIconEllipsis aria-label="More items" slot="after" />
              </div>
              <CatList>{breadCrumbsItems}</CatList>
            </CatContextualMenu>
          </CatBreadcrumbsItem>
        )}
        {linksLength > 1 && (
          <CatBreadcrumbsItem
            className={styles[readOnlyItemStyles]}
            key={uuid()}
            href={links[lastLink].value}
            isLast
            isActive={!isWithoutActiveItem}
          >
            <span className="text-capitalize text-start w-100">
              {links[lastLink].label}
            </span>
          </CatBreadcrumbsItem>
        )}
      </div>
    </CatBreadcrumbs>
  );
};

export default BreadCrumbMobileClient;
